import { createRouter, createWebHistory } from 'vue-router'
import TransporteEventual from '../views/TransporteEventualPage.vue'
import Buffet from '../views/BuffetPage.vue'
import Servicos from '../views/Servicos.vue'
import Home from '../App.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/apps/interface_centralizada/',
        name: 'servicos',
        component: Servicos
    },
    {
        path: '/transporte_eventual/:tipo',
        name: 'transporte_eventual',
        component: TransporteEventual  
    },
    {
        path: '/buffet/',
        name: 'buffet',
        component: Buffet  
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;